import { YouTube } from '@blocks/kit';
import React from 'react';
export default {
  YouTube,
  React
};